import artificial_intelligence_and_data_science_icon from '../../assets/top_engineering-colleges_in-india/artificial_intelligence_and_data_science_icon.png'
import civil_engineer_icon from '../../assets/top_engineering-colleges_in-india/civil_engineer_icon.png'
import computer_science_and_engineering_icon from '../../assets/top_engineering-colleges_in-india/computer_science_and_engineering_icon.png'
import computer_science_and_technology_icon from '../../assets/top_engineering-colleges_in-india/computer_science_and_technology_icon.png'
import department_of_electronics_and_communication from '../../assets/top_engineering-colleges_in-india/department_of_electronics_and_communication.png'
import department_of_mechanical_engineering_icon from '../../assets/top_engineering-colleges_in-india/department_of_mechanical_engineering_icon.png'
import information_and_technology_icon from '../../assets/top_engineering-colleges_in-india/information_and_technology_icon.png'
import master_of_computer_application_icon from '../../assets/top_engineering-colleges_in-india/master_of_computer_application_icon.png'




export const institutesDetails = [
  {
    _id: "1",
    instituteName: "Computer Science & Engineering",
    instituteLink: "/Overview/66e7f7154e3cc865577c318f/computer-science-and-engineering",
    instituteImage: computer_science_and_engineering_icon,
  },
  {
    _id: "2",
    instituteName: "Information Technology",
    instituteLink: "/Overview/66e82451ccd836f84801f23a/information-technology",
    instituteImage: information_and_technology_icon,
  },
  {
    _id: "3",
    instituteName: "Department of Electronics and Communication",
    instituteLink: "/Overview/66e82a92ccd836f84801f2dd/department-of-electronics-and-communication",
    instituteImage: department_of_electronics_and_communication,
  },
  {
    _id: "4",
    instituteName: "Department of Mechanical Engineering",
    instituteLink: "/Overview/66e83053ccd836f84801f39c/department-of-mechanical-engineering",
    instituteImage: department_of_mechanical_engineering_icon,
  },
  {
    _id: "5",
    instituteName: "Department of Civil Engineering",
    instituteLink: "/Overview/66e91028ccd836f84801f4a3/department-of-civil-engineering",
    instituteImage: civil_engineer_icon,
  },
  {
    _id: "6",
    instituteName: "Artificial Intelligence and Data Science",
    instituteLink: "/Overview/66e91cacccd836f84801f59a/artificial-intelligence-and-data-science",
    instituteImage: artificial_intelligence_and_data_science_icon,
  },
  {
    _id: "7",
    instituteName: "Computer Science and Information Technology",
    instituteLink: "/Overview/66e91fd6ccd836f84801f61c/computer-science-and-information-technology",
    instituteImage: computer_science_and_technology_icon,
  },
  {
    _id: "8",
    instituteName: "Master of Computer Application",
    instituteLink: "/Overview/67613e8460faee5f92ef2998/master-of-computer-application",
    instituteImage: master_of_computer_application_icon,
  },
];


export const faqs = [
  {
    id: "1",
    question: "What makes CDGI one of the top engineering colleges in Indore?",
    answer:
      "Our NAAC A+ rating, placement record, advanced curriculum, and expert faculty make us a top choice for engineering aspirants.",
  },
  {
    id: "2",
    question: "What B.Tech branches are available at CDGI?",
    answer:
      "We offer CSE, IT, AI & Data Science, ECE, Mechanical, and Civil Engineering.",
  },
  {
    id: "3",
    question: "Does CDGI offer placement support?",
    answer:
      "Yes. We provide 100% placement assistance including resume workshops, training, and company drives.",
  },
  {
    id: "4",
    question: "Is hostel accommodation available?",
    answer:
      "Yes. We provide separate, Wi-Fi enabled hostel facilities for boys and girls.",
  },
  {
    id: "5",
    question: "How can I apply for CDGI's engineering programs?",
    answer:
      "Visit www.cdgi.edu.in and apply online through our B.Tech admissions portal.",
  },
];

export const allCoursesForForm = [
  "Engineering Courses [CS, IT, AI & DS, CSIT]",
  "Engineering Course [Electronics & Comm. Engg.]",
  "Engineering Course [Mechanical Engineering]",
  "Engineering Course [Civil Engineering]",
  "Pharmacy Courses [B.Pharm, D.Pharm]",
  "Pharmacy Course [M.Pharm]",
  "Management Courses [MBA(FT,MM,FA)]",
  "Professional Courses [BBA]",
  "Professional Courses [BCA]",
  "Professional Courses [B.Com]",
  "Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]",
  "MCA Course",
];

export const mbaHighlights = [
  "NAAC A+ Accredited Institution",
  "Approved by AICTE, New Delhi ",
  "Affiliated to RGPV, Bhopal ",
  "Industry-Ready Curriculum with Certifications",
  "Dedicated Innovation & Research Labs ",
  "100+ Placement Partners ",
  "Entrepreneurship Cell and Incubation Support",
];
